import React, { useCallback, use, useMemo, useState } from "react";

interface DiffDisplayContextValue {
  targetSearchId: number | undefined;
  sourceSearchId: number | undefined;
  setActive: (
    targetSearchId: number,
    sourceSearchId: number | undefined
  ) => void;
  clear: () => void;
}
export const DiffDisplayContext = React.createContext<
  DiffDisplayContextValue | undefined
>(undefined);

export const useDiffDisplayContext = () => {
  const res = use(DiffDisplayContext);
  if (res === undefined)
    throw new Error("useDiffDisplayContext must be used within a provider");
  return res;
};

export const DiffDisplayContextProvider = ({
  children,
}: React.PropsWithChildren) => {
  const [hoverState, setHoverState] = useState<
    Pick<DiffDisplayContextValue, "targetSearchId" | "sourceSearchId">
  >({
    targetSearchId: undefined,
    sourceSearchId: undefined,
  });
  const setActive: DiffDisplayContextValue["setActive"] = useCallback(
    (targetSearchId, sourceSearchId) => {
      setHoverState({
        targetSearchId,
        sourceSearchId,
      });
    },
    []
  );
  const clear = useCallback(() => {
    setHoverState({ targetSearchId: undefined, sourceSearchId: undefined });
  }, []);
  const providerValue = useMemo(
    () => ({
      ...hoverState,
      setActive,
      clear,
    }),
    [hoverState, setActive, clear]
  );
  return (
    <DiffDisplayContext value={providerValue}>{children}</DiffDisplayContext>
  );
};
